import { useMemo } from 'react';

import { paths } from 'src/routes/paths';

import SvgColor from 'src/components/svg-color';
import { useAuthContext } from 'src/auth/hooks';
import Iconify  from 'src/components/iconify/index';

// ----------------------------------------------------------------------

const iconCustom = (name) => (
  <Iconify  icon= {name} />
);



// ----------------------------------------------------------------------

export function useNavData() {
  const { user: dataUser } = useAuthContext();
  let dataFilteredWithPermission = [];

  const data = useMemo(
    () => [
      {
        subheader: 'Configuracion',
        items: [
          { title: 'Usuarios', path: paths.dashboard.configuration.user.list, icon: iconCustom("mdi:users"), componente: 'Usuarios', },
          { title: 'Roles', path: paths.dashboard.configuration.roles.list, icon: iconCustom("eos-icons:role-binding"), componente: 'Roles', },
          { title: 'Relación servicio - rol', path: paths.dashboard.configuration.relationRolService.list, icon: iconCustom("mdi:relation-many-to-only-one"), componente: 'ServiciosRol', },
        ],
      },
      {
        subheader: 'PROCESOS',
        items: [
          { title: 'Sucursales', path: paths.dashboard.configuration.branches.list, icon: iconCustom("material-symbols:store"), componente: 'Sucursales', },
          { title: 'Empresas', path: paths.dashboard.configuration.companies.list, icon: iconCustom("ion:business"), componente: 'Empresas', },
          { title: 'Productos', path: paths.dashboard.configuration.products.list, icon: iconCustom("icon-park-outline:ad-product"), componente: 'Productos', },
          { title: 'Pedidos', path: paths.dashboard.configuration.orders.list, icon: iconCustom("material-symbols:order-approve-rounded"), componente: 'Pedidos', },
        ],
      },
      {
        subheader: 'REPORTES',
        items: [
          { title: 'Historial de pedidos', path: paths.dashboard.configuration.ordersHistory.list, icon: iconCustom("icon-park-solid:doc-search"), componente: 'HistorialPedidos', },
          { title: 'Finanzas', path: paths.dashboard.configuration.finance.list, icon: iconCustom("material-symbols:finance"), componente: 'Finanzas', },
        ],
      },
    ],
    []
  );

  if(dataUser) {
    const componentsAccessUser = dataUser?.routes?.map(ruta => {
      let components = [];
      if(ruta.subMenu) {
        components = ruta.subMenu.map((component) => (component.componente.toLowerCase()))
      }
      else {
        components = ruta.componente.toLowerCase();
      }
      return components;
    }).flat();
    
    dataFilteredWithPermission = data.map((item) => {
      let itemsFilteres = {};
      if(item.items.length > 0) {
        itemsFilteres = item.items.filter((servicio) => (componentsAccessUser.includes(servicio.componente.toLowerCase())) );
      }
      return {
        items: itemsFilteres,
        subheader:  item.subheader,
      }
    });
    
    dataFilteredWithPermission = dataFilteredWithPermission.filter((array) => (array.items.length>0));
    
  }

  return dataFilteredWithPermission || data;
}
